import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';
import { IBenefitsRewards } from './IBenefitsRewards';
import { classes } from '~utils/Classes';
import { marketingPageSections as ms } from '~views/marketing-page/sections';
import { BenefitsRewardsTableThead } from '~views/marketing-page/benefits-rewards/BenefitsRewardsTableThead';
import { BenefitsRewardsPointAccordionWrapper } from '~views/marketing-page/benefits-rewards/BenefitsRewardsPointAccordionWrapper';
import { LoyaltyTierDiamond } from '~views/LoyaltyTierDiamond';

export const TEST_ID_BENEFITS_REWARDS_SECTION = 'loyalty-marketing-page-benefits-rewards';
const benefitsRewardsID = 'benefits-rewards';

const benefitsRewardsClass = classes('loyalty-marketing-page-benefits-rewards');
const benefitsRewardsHeaderClass = classes('loyalty-marketing-page-benefits-rewards__header');
const benefitsRewardsHeadingClass = classes(
    'loyalty-marketing-page-benefits-rewards__header__heading'
);
const benefitsRewardsSubheadingClass = classes(
    'loyalty-marketing-page-benefits-rewards__header__subHeading'
);
const benefitsRewardsFooterClass = classes('loyalty-marketing-page-benefits-rewards__footer');
const benefitsRewardsSubFooterClass = classes('loyalty-marketing-page-benefits-rewards__subFooter');
const benefitsRewardsLogoClass = classes('loyalty-marketing-page-benefits-rewards__logo');
const benefitsRewardsLogoPcClass = classes('loyalty-marketing-page-benefits-rewards__logo__pc');
const benefitsRewardsAccordionWrapperClass = classes(
    'loyalty-marketing-page-benefits-rewards__accordionWrapper'
);
const benefitsRewardsTableWrapperClass = classes(
    'loyalty-marketing-page-benefits-rewards__tableWrapper'
);
const benefitsRewardsTableTableHeading3Class = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading3'
);
const benefitsRewardsTableTableHeading3NoSubheadingClass = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading3',
    'elc-loyalty-marketing-page-benefits-rewards__tableHeading3__noSubheading'
);
const benefitsRewardsTableTableHeading4Class = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading4'
);
const benefitsRewardsTableTableNoSubtitle = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading4',
    'elc-loyalty-marketing-page-benefits-rewards__noSubheading'
);
const benefitsRewardsTableClass = classes('loyalty-marketing-page-benefits-rewards__table');
const benefitsRewardsTableBodyClass = 'loyalty-marketing-page-benefits-rewards__tableBody';
const benefitsRewardsTableImageClass = classes(
    'loyalty-marketing-page-benefits-rewards__table__backgroundImage'
);
const benefitsRewardsTableBenefitItem = classes(
    'loyalty-marketing-page-benefits-rewards__table__benefit'
);
const benefitsRewardsTableRowHeadersClass = classes(
    'loyalty-marketing-page-benefits-rewards__table__rowHeaders'
);
const benefitsRewardsTableDataCellClass = classes(
    'loyalty-marketing-page-benefits-rewards__table__dataCell'
);
const faqSectionWrapperClass = classes(
  'loyalty-marketing-page-benefits-rewards__faq__wrapper'
);
const faqSectionClass = classes(
  'loyalty-marketing-page-benefits-rewards__faq__section'
);

const BenefitsRewardsSectionWrapper = styled.div<{
    textColor: string;
}>`
    grid-area: ${ms.benefitsRewards};
    color: ${({ textColor }) => `#${textColor}`};
`;

const BenefitsRewardsTable = styled.table<{ backgroundColor: string | undefined }>`
    background-color: ${({ backgroundColor }) => `#${backgroundColor}`};
    grid-area: benefitsRewardsTable;
`;
const BenefitsRewardsTableHeading3 = styled.p<{ textColor: string }>`
    color: ${({ textColor }) => `#${textColor}`};
    grid-area: benefitsRewardsTableHeading3;
`;
const BenefitsRewardsTableHeading4 = styled.p<{ textColor: string }>`
    color: ${({ textColor }) => `#${textColor}`};
    grid-area: benefitsRewardsTableHeading4;
`;
const BenefitsRewardsHeaderWrapper = styled.div`
    grid-area: MarketingPageBenefitsRewardsHeader;
`;
const BenefitsRewardsSubheaderWrapper = styled.div`
    grid-area: MarketingPageBenefitsRewardsSubheader;
`;
const BenefitsRewardsLogoWrapper = styled.div`
    grid-area: MarketingPageBenefitsRewardsLogo;
`;
const BenefitsRewardsLogoWrapperPC = styled.div`
    grid-area: MarketingPageBenefitsRewardsLogo;
`;
const BenefitsRewardsFooterWrapper = styled.div`
    grid-area: MarketingPageBenefitsRewardsFooter;
`;
const BenefitsRewardsSubFooterWrapper = styled.div`
    grid-area: MarketingPageBenefitsRewardsSubFooter;
`;
const BenefitsRewardsAccordionWrapper = styled.div`
    grid-area: MarketingPageBenefitsRewardsAccordion;
`;
const BenefitsRewardsTableWrapper = styled.div`
    grid-area: MarketingPageBenefitsRewardsTable;
`;
const FaqSectionWrapper = styled.div``;
const FaqSection = styled.div``;

export const BenefitsRewards = observer(function BenefitsRewardsSection({
    benefitsRewards,
    viewController: { groupBenefitsByTier, onLinkClick }
}: IBenefitsRewards) {
    const data = groupBenefitsByTier(benefitsRewards.tierLabel, benefitsRewards.listBenefits);
    const handleLinkClick = (e: React.MouseEvent<HTMLInputElement>) => {
        const target = e.target as HTMLAnchorElement;
        if (target.tagName === 'A') {
            onLinkClick(`${target.innerText}`);
        }
    };

    return (
        <BenefitsRewardsSectionWrapper
            className={benefitsRewardsClass}
            data-test-id={TEST_ID_BENEFITS_REWARDS_SECTION}
            textColor={benefitsRewards.textColor.hex}
            id={benefitsRewardsID}
        >
            <BenefitsRewardsLogoWrapperPC className={benefitsRewardsLogoPcClass}>
                <img
                    src={benefitsRewards.loyaltyBenefitsRewardsImagePc.src}
                    alt={benefitsRewards.loyaltyBenefitsRewardsImagePc.alt}
                />
            </BenefitsRewardsLogoWrapperPC>
            <div className={benefitsRewardsHeaderClass}>
                <BenefitsRewardsLogoWrapper className={benefitsRewardsLogoClass}>
                    <img
                        src={benefitsRewards.loyaltyBenefitsRewardsLogo.src}
                        alt={benefitsRewards.loyaltyBenefitsRewardsLogo.alt}
                    />
                </BenefitsRewardsLogoWrapper>
                <BenefitsRewardsHeaderWrapper
                    className={benefitsRewardsHeadingClass}
                    dangerouslySetInnerHTML={{ __html: benefitsRewards.heading }}
                    onClick={handleLinkClick}
                    role="none"
                />
                <BenefitsRewardsSubheaderWrapper
                    className={benefitsRewardsSubheadingClass}
                    dangerouslySetInnerHTML={{ __html: benefitsRewards.subHeading }}
                />
            </div>
            <BenefitsRewardsAccordionWrapper className={benefitsRewardsAccordionWrapperClass}>
                <BenefitsRewardsPointAccordionWrapper
                    mapOfItems={data}
                    sign={benefitsRewards.sign}
                    textColor={benefitsRewards.textColor}
                />
            </BenefitsRewardsAccordionWrapper>
            <BenefitsRewardsTableWrapper className={benefitsRewardsTableWrapperClass}>
                <BenefitsRewardsTable
                    backgroundColor={benefitsRewards.sectionBackground.hex}
                    className={benefitsRewardsTableClass}
                >
                    <BenefitsRewardsTableThead
                        data={data}
                        textColor={benefitsRewards.textColor}
                        tableLogo={benefitsRewards.loyaltyBenefitsRewardsTableLogo}
                    />
                    <tbody className={benefitsRewardsTableBodyClass}>
                        {benefitsRewards.listBenefits.map((item, index) => (
                            <tr className={benefitsRewardsTableRowHeadersClass}>
                                <th className={benefitsRewardsTableBenefitItem}>
                                    <BenefitsRewardsTableHeading3
                                        textColor={benefitsRewards.textColor.hex}
                                        className={
                                            item.subHeading.length
                                                ? benefitsRewardsTableTableHeading3Class
                                                : benefitsRewardsTableTableHeading3NoSubheadingClass
                                        }
                                    >
                                        {item.heading}
                                    </BenefitsRewardsTableHeading3>
                                    <BenefitsRewardsTableHeading4
                                        textColor={benefitsRewards.textColor.hex}
                                        className={
                                            item.subHeading.length
                                                ? benefitsRewardsTableTableHeading4Class
                                                : benefitsRewardsTableTableNoSubtitle
                                        }
                                    >
                                        {item.subHeading}
                                    </BenefitsRewardsTableHeading4>
                                </th>
                                <td className={benefitsRewardsTableDataCellClass}>
                                    {item.levelOne && (
                                        <LoyaltyTierDiamond
                                            loyaltyTier={1}
                                            textColor={
                                                benefitsRewards.tierLabel[0]?.levelColor?.hex
                                            }
                                            sign={benefitsRewards.sign}
                                        />
                                    )}
                                </td>
                                <td className={benefitsRewardsTableDataCellClass}>
                                    {item.levelTwo && (
                                        <LoyaltyTierDiamond
                                            loyaltyTier={2}
                                            textColor={
                                                benefitsRewards.tierLabel[1]?.levelColor?.hex
                                            }
                                            sign={benefitsRewards.sign}
                                        />
                                    )}
                                </td>
                                <td className={benefitsRewardsTableDataCellClass}>
                                    {item.levelThree && (
                                        <LoyaltyTierDiamond
                                            loyaltyTier={3}
                                            textColor={
                                                benefitsRewards.tierLabel[2]?.levelColor?.hex
                                            }
                                            sign={benefitsRewards.sign}
                                        />
                                    )}
                                </td>
                                {item.levelFourth ? (
                                    <td className={benefitsRewardsTableDataCellClass}>
                                        {item.levelFourth && (
                                            <LoyaltyTierDiamond
                                                loyaltyTier={4}
                                                textColor={
                                                    benefitsRewards.tierLabel[2]?.levelColor?.hex
                                                }
                                                sign={benefitsRewards.sign}
                                            />
                                        )}
                                    </td>
                                ) : null}
                            </tr>
                        ))}
                    </tbody>
                </BenefitsRewardsTable>
            </BenefitsRewardsTableWrapper>
            <BenefitsRewardsFooterWrapper
                className={benefitsRewardsFooterClass}
                dangerouslySetInnerHTML={{ __html: benefitsRewards.footer }}
                onClick={handleLinkClick}
                role="none"
            />
            <BenefitsRewardsSubFooterWrapper
                className={benefitsRewardsSubFooterClass}
                dangerouslySetInnerHTML={{ __html: benefitsRewards.subfooter }}
            />
            <img
                className={benefitsRewardsTableImageClass}
                src={benefitsRewards.sectionBackground.src}
                alt={benefitsRewards.sectionBackground.alt}
            />
            <FaqSectionWrapper className={faqSectionWrapperClass}>
                <FaqSection className={faqSectionClass} onClick={handleLinkClick} role="none">
                    <strong>HAVE QUESTIONS?</strong>
                    <p>&nbsp;</p>
                    <p className='elc-loyalty-marketing-page-dynamic-redirection elc-loyalty-marketing-page-dynamic-redirection-faq'>
                      <a href="/mac-lover-faqs">VIEW FAQ</a>
                    </p>
                </FaqSection>
            </FaqSectionWrapper>
        </BenefitsRewardsSectionWrapper>
    );
});
